.table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-body2-fontSize, 0.875rem);
}

.table th,
.table td {
  padding: 8px 16px;
  text-align: left;
  border-bottom: 1px solid var(--tuna-palette-divider);
}

.table th {
  font-weight: 500;
  color: var(--tuna-palette-text-secondary);
  font-size: var(--tuna-typography-body2-fontSize, 0.875rem);
}

.table td {
  color: var(--tuna-palette-text-primary);
}

.table tbody tr:last-child td {
  border-bottom: none;
}

.small th,
.small td {
  padding: 4px 8px;
}
